import { render, staticRenderFns } from "./tablaTransac.vue?vue&type=template&id=8a84376c&scoped=true"
import script from "./tablaTransac.vue?vue&type=script&lang=js"
export * from "./tablaTransac.vue?vue&type=script&lang=js"
import style0 from "./tablaTransac.vue?vue&type=style&index=0&id=8a84376c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84376c",
  null
  
)

export default component.exports